import { AuthorizationScope } from '@api/graphql/types';

export const manageRoutePermissions = {
  manageExport: [AuthorizationScope.QueryAllSectionsFiles],
  manageTeachingUnitsImport: [
    AuthorizationScope.QueryTeachingUnitsSpreadsheetImportDiff,
    AuthorizationScope.QueryTeachingUnitsSpreadsheetImportHistories,
  ],
};
